import { DeleteConfirmationModal } from 'components/core-ui/DeleteConfirmationModal'

export const DeleteDelegateModal = ({ isModalOpen, closeModal, managerId, itemId, setShouldRefreshData }) => (
    <DeleteConfirmationModal
        isModalOpen={isModalOpen}
        actionUrl={`/iam/external-partners/managers/${managerId}/delegate/:id`}
        content='Are you sure you want to remove this delegate from manager? This action cannot be undone.'
        closeModal={closeModal}
        itemId={itemId}
        setShouldRefreshData={setShouldRefreshData}
        succesMessage='Delegate deactivated successfully from this manager'
        errorMessage='Failed to deactivate delegate from this manager.'
    />
)